document.addEventListener("DOMContentLoaded", initTrackOrderFormHandler);

const ORDER_STATUSES = {
	1: 1,
	2: 1,
	3: 1,
	20: 1,
	60: 2,
	61: 2,
	62: 2,
	70: 2,
	80: 3,
	81: 3,
	90: 4,
};

const BAR_STEPS = [
	{ label: 1, dateKey: "1" },
	{ label: 2, dateKey: "20" },
	{ label: 3, dateKey: "80" },
	{ label: 4, dateKey: "90" },
];

function getStatusFromChangeDates(statusChangeDates) {
	if (!statusChangeDates) return "";

	const statusPriority = [
		"90",
		"80",
		"70",
		"60",
		"20",
		"1",
		"95",
		"96",
		"97",
		"98",
	];

	for (const statusCode of statusPriority) {
		if (statusChangeDates[statusCode]) return statusCode;
	}

	return "";
}

function getTrackOrderLabels() {
	const node = document.getElementById("track-order-labels");
	if (!node) return { status: {}, bar: {}, messages: {} };

	try {
		return JSON.parse(node.textContent);
	} catch {
		return { status: {}, bar: {}, messages: {} };
	}
}

function initTrackOrderFormHandler() {
	const trackOrderForm = document.getElementById("track-order-form");
	const errorMessage = document.getElementById("track-order-error-message");
	const errorText = errorMessage?.querySelector("p.note.form-error");
	const submitButton = document.getElementById("track-order-submit-button");
	const pizzabarContainer = document.getElementById(
		"track-order-pizzabar-container",
	);
	const orderTableContainer = document.getElementById(
		"track-order-table-container",
	);
	const labels = getTrackOrderLabels();
	const messages = labels.messages || {};

	trackOrderForm?.addEventListener("submit", async (event) => {
		event.preventDefault();
		submitButton.disabled = true;

		errorMessage?.classList.add("hide-down");
		pizzabarContainer?.classList.add("hide-down");
		orderTableContainer?.classList.add("hide-down");

		const formData = new FormData(trackOrderForm);
		const orderEmail = formData.get("email");
		const orderName = formData.get("order_number");

		try {
			const response = await fetch("/apps/api/orders/status/details", {
				method: "POST",
				headers: { "Content-Type": "application/json" },
				body: JSON.stringify({ orderName, orderEmail }),
			});

			if (!response.ok) throw new Error(messages.error);

			const contentType = response.headers.get("content-type");
			if (!contentType || !contentType.includes("application/json")) {
				throw new Error(messages.error);
			}

			const responseJson = await response.json();

			if (!responseJson.success) {
				throw new Error(responseJson.message || messages.error);
			}

			if (!responseJson.statusChangeDates) {
				throw new Error(messages.not_found);
			}

			const pizzabarWrapper = document.getElementById(
				"track-order-pizzabar-wrapper",
			);
			const orderTableWrapper = document.getElementById(
				"track-order-table-wrapper",
			);

			if (pizzabarWrapper) pizzabarWrapper.innerHTML = "";
			if (orderTableWrapper) orderTableWrapper.innerHTML = "";

			const orderTableTemplate = document.getElementById(
				"order-table-template",
			);
			const orderTableClone = orderTableTemplate.content.cloneNode(true);
			const orderRow = orderTableClone.querySelector(".boa-order-row");

			if (!orderRow) return;

			const orderNameCell = orderRow.querySelector(".boa-row-name");
			const orderDateCell = orderRow.querySelector(".boa-row-date");
			const orderCountCell = orderRow.querySelector(".boa-row-count");
			const orderTotalCell = orderRow.querySelector(".boa-row-total");
			const orderStatusCell = orderRow.querySelector(".boa-row-status");

			if (
				!orderNameCell ||
				!orderDateCell ||
				!orderCountCell ||
				!orderTotalCell ||
				!orderStatusCell
			)
				return;

			orderNameCell.textContent = orderName;

			if (responseJson.orderDate) {
				orderDateCell.textContent = new Date(
					responseJson.orderDate,
				).toLocaleDateString("he-IL", {
					day: "2-digit",
					month: "2-digit",
					year: "numeric",
				});
			}

			orderCountCell.textContent =
				responseJson.totalItemCount?.toString() || "0";

			if (responseJson.totalAmount !== undefined) {
				const totalAmount = parseFloat(responseJson.totalAmount);
				orderTotalCell.textContent =
					totalAmount === 0 ? messages.refunded : `₪ ${totalAmount.toFixed(2)}`;
			}

			const statusValue = responseJson.status
				? responseJson.status.toString()
				: getStatusFromChangeDates(responseJson.statusChangeDates);

			if (!statusValue) return;

			orderStatusCell.textContent =
				labels.status[statusValue] || messages.in_process;
			orderTableWrapper.appendChild(orderTableClone);
			orderTableContainer?.classList.remove("hide-down");

			if (["96", "97"].includes(statusValue)) return;

			const pizzabarTemplate = document.getElementById("pizzabar-template");
			if (!pizzabarWrapper || !pizzabarTemplate)
				throw new Error("Missing required DOM elements");

			const pizzabarClone = pizzabarTemplate.content.cloneNode(true);
			const pizzabar = pizzabarClone.querySelector(".pizzabar");
			if (!pizzabar) throw new Error("Template structure error");

			const current = ORDER_STATUSES[statusValue] || 1;
			const steps = pizzabar.querySelectorAll(".pizzabar-step");
			const lines = pizzabar.querySelectorAll(".pizzabar-line");

			steps.forEach((step, index) => {
				step.classList.add(index + 1 <= current ? "is-done" : "is-pending");
			});

			lines.forEach((line, index) => {
				if (index < current - 1) line.classList.add("is-done");
			});

			const stepTitles = pizzabar.querySelectorAll(".step-title");
			const stepDates = pizzabar.querySelectorAll(".step-date");

			BAR_STEPS.forEach(({ label, dateKey }, index) => {
				if (stepTitles[index])
					stepTitles[index].textContent = labels.bar[label] || "";
				if (stepDates[index])
					stepDates[index].textContent =
						responseJson.statusChangeDates[dateKey] || "";
			});

			pizzabarWrapper.appendChild(pizzabarClone);
			pizzabarContainer?.classList.remove("hide-down");
		} catch (error) {
			let errorMessageText = messages.error;

			if (
				error.message &&
				error.message !== messages.error &&
				error.message !== messages.not_found
			) {
				errorMessageText = error.message;
			}

			if (errorText) errorText.textContent = errorMessageText;
			errorMessage?.classList.remove("hide-down");
		} finally {
			submitButton.disabled = false;
		}
	});
}
